import React from 'react'
import TableCellDesktop from './TableCellDesktop'

const TableCellComptabiliteMotif = ({ item }) => {
  return (
    <TableCellDesktop
      max={150}
      value={item.motif}
    />
  )
}

export default TableCellComptabiliteMotif
